import moment from "moment";

export default function fromNow(value) {
    if (value) {
        moment.langData('en')._relativeTime.s = "seconds";
        return moment(String(value)).fromNow();
    }
}
